export default function Lightning({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 2L3 14H12L10 22L21 10H12L13 2Z" fill="currentColor" />
    </svg>
  )
}
